 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];


 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 	};


 	// The module cache
 	var installedModules = {};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		30: 0
 	};



 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"0":"/node_modules/litepicker-polyfills-ie11/dist","1":"adobeDigitalData","2":"alertSignUpSection","3":"article","4":"binders","7":"bulkDownload","8":"citedBy","9":"confirmationDialog","10":"copyText","11":"dashboardToolbar","12":"datepicker","13":"disableADBlocker","14":"downloadCitations","15":"eventPage","16":"examCertificate","17":"exportCitation","18":"fancybox","19":"favorites","20":"headerAlt","21":"healthcareDisclaimer","22":"institutionBanner","23":"institutionDetails","24":"institutionSearch","25":"keveladplaceholder","26":"lazy-imports","27":"loadAbst","28":"loi","29":"loiAccordion","31":"menu","32":"mrw","33":"pd","34":"personalInformation","36":"profile","37":"progressBar","38":"publicationVersion","39":"readCubeShare","40":"recommendToLibrarian","41":"requestidlecallback-polyfill","42":"sciteMetrics","43":"search","44":"showRecommended","45":"sidebarSections","46":"slideshow","47":"slot-license-consumption","48":"slotLicense","49":"tfa","50":"toggleTable","51":"topContent","52":"truncate","53":"utm","54":"vendors~article","55":"vendors~dynamic-imports","56":"vendors~fancybox","57":"vendors~fileUploader","58":"vendors~ie-imports","59":"vendors~lazy-imports","60":"vendors~pd","61":"vendors~profile","62":"vendors~sciteMetrics","63":"vendors~search","64":"vendors~slideshow"}[chunkId]||chunkId) + "-" + {"0":"dd7d3f516d53a02fcab5","1":"579c28a74d9f0a9b7a1c","2":"30b933c26edfa6c96cd9","3":"ae97dbacb6a83951b0e3","4":"0d51f37601a0be726419","7":"4774dd0bbcf99e69a2a2","8":"f0fa8d71fee94b986d93","9":"827469d5d736101ec7cd","10":"b2b39012f46c187404cc","11":"ced68192e91bdde724a9","12":"d1b1343b0ba055700699","13":"a72da957d0981f596dd9","14":"7569cdfdff67d465bb65","15":"f8d554441022784cbbd7","16":"4f7336dec7f23c177aab","17":"d16a44cabd01c07f08fd","18":"3d06fa2d3658eda0245c","19":"082f7f6c61f93def8d27","20":"d7e228e97d27ec30b8ad","21":"64ac5d4b37551bbbddd7","22":"1addac7c7cf11b654243","23":"448beec749ca9b02ac71","24":"ebf63c3e174671e26c51","25":"d50e8db5012b1bc76d6f","26":"39b89f66dc489b1bc699","27":"946fb9ce7a096e5d2124","28":"ece559b71bbb3e08c949","29":"074073a3e8fe99ba6f93","31":"24aea608c8e250b096d2","32":"25498cb05153d6e2d548","33":"2b8d8f4eb3a512fb564d","34":"344c99e64eaef44ee836","36":"21e2f67b594baef95af7","37":"92eaf3d859d0cd3b160a","38":"9bfa56036523b9387248","39":"8e14b356abeacf25b56c","40":"3a91cda96b3e8beac719","41":"74dd68e7a50ffa35a71c","42":"00bd9c1edfe766409977","43":"afbf5b242f217fa78963","44":"f0ac71068039209b2cec","45":"6d6ae06a9271e161adae","46":"acd576768261c2860291","47":"5415b4ab7961eafcef23","48":"5d66568bae6e237e2af0","49":"ece0b7636736b8f24056","50":"566810e10b06afcb86bb","51":"f221fb2506aa367f3e5d","52":"70929fc975a3bd3bdcf7","53":"cb342448fc266e09ffb5","54":"935eed5ae70ccd5af1c5","55":"2037e3b2135512387d83","56":"ea74b98e2bb6aadab00a","57":"67f7fafa261868c7519c","58":"3362d92ef2579309191e","59":"13c91396a0c1b2eec7a6","60":"65338a1e9143dbda289e","61":"3ccdf43b9cc65816ac9c","62":"69b4b89487d86de40a01","63":"419b9f138aeeb5265e53","64":"1d1a4f8a6656b9c3338a","65":"be7e3a8e180d9b950797"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// Load entry module and return exports
 	return __webpack_require__(__webpack_require__.s = 104);
